import { generateOneLinkURL } from "./af-smart-script";

export default function updateAppPlayStoreLinks(
  oneLinkURL,
  campaign,
  floor,
  affId,
  customerRef,
  channel
) {
  const storeResult = generateOneLinkURL({
    oneLinkURL,
    afParameters: {
      mediaSource: { keys: ["store_image"], defaultValue: "store_image" },
      campaign,
      deepLinkValue: {
        keys: [],
        defaultValue: encodeURIComponent(
          `asos://home?channelref=web_dta_storeimg&floor=${floor}${affId}${customerRef}`
        ),
      },
      channel,
    },
  });

  if (storeResult?.clickURL) {
    [
      ...document.querySelectorAll(
        'main a[href*="itunes.apple.com"], main a[href*="play.google.com"]'
      ),
    ].forEach((element) => (element.href = storeResult.clickURL));
  }
}
